import { createAction } from 'redux-act';
///////////////////////////////////////////////////////////////////////////////////////////////////

export const createReferenceRequest = createAction('createReferenceRequest');
export const getItemReferenceRequest = createAction('getItemReferenceRequest');
export const updateItemReferenceRequest = createAction('updateItemReferenceRequest');
export const deleteItemReferenceRequest = createAction('deleteItemReferenceRequest');
